import type { Categories, CategoryConfig } from "emoji-picker-react";

/** Library category id -> `messages.emojiCategories.*` key, in the picker's default order
 *  (the `custom` category is only shown with custom emojis, which we never pass). */
const CATEGORY_KEYS = [
  ["suggested", "suggested"],
  ["smileys_people", "smileysPeople"],
  ["animals_nature", "animalsNature"],
  ["food_drink", "foodDrink"],
  ["travel_places", "travelPlaces"],
  ["activities", "activities"],
  ["objects", "objects"],
  ["symbols", "symbols"],
  ["flags", "flags"],
] as const;

/** Localized `categories` prop for emoji-picker-react (its headings default to English). Enum
 *  values are cast so the ~420 KB library is not imported at runtime from here. */
export function buildEmojiCategories(t: (key: string) => string): CategoryConfig[] {
  return CATEGORY_KEYS.map(([category, key]) => ({
    category: category as Categories,
    name: t(`emojiCategories.${key}`),
  }));
}
